mutation DeleteMailerConfigs($ids: [ID!]!) {
  deleteMailerConfigs(ids: $ids) {
    id
    deletedAt
  }
}
